import React, { useState } from "react";
import { useAgendamento } from "../../context/AgendamentoContext";
import { HistoricoData, HistoricoItem, HistoricoLista, StatusPill } from "./styles";
import { Button } from "../../pages/Acessos/styles";

const TONE_BY_STATUS = {
  ok: "success",
  erro: "danger",
  pulado: "warning",
};

function formatarTimestamp(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString("pt-BR");
  } catch {
    return iso;
  }
}

export default function HistoricoExecucoes() {
  const { historico } = useAgendamento();
  const [aberto, setAberto] = useState(false);

  if (historico.length === 0) {
    return null;
  }

  return (
    <div>
      <Button
        type="button"
        $variant="secondary"
        onClick={() => setAberto((v) => !v)}
        style={{ marginBottom: 8 }}
      >
        {aberto ? "Ocultar histórico" : `Ver histórico (${historico.length})`}
      </Button>
      {aberto && (
        <HistoricoLista>
          {historico.map((h) => (
            <HistoricoItem key={h.id}>
              <HistoricoData>{formatarTimestamp(h.fim || h.inicio)}</HistoricoData>
              <span>
                <strong>{h.painelLabel || h.painelId}</strong>{" "}
                <small style={{ opacity: 0.6 }}>· {h.formato.toUpperCase()}</small>
                {h.arquivoNome && (
                  <div style={{ fontSize: 11, opacity: 0.7 }}>{h.arquivoNome}</div>
                )}
                {h.erro && (
                  <div style={{ fontSize: 11, color: "#c62828" }}>{h.erro}</div>
                )}
                {h.aviso && (
                  <div style={{ fontSize: 11, color: "#b88300" }}>{h.aviso}</div>
                )}
              </span>
              <StatusPill $tone={TONE_BY_STATUS[h.status] || "default"}>
                {h.status}
              </StatusPill>
            </HistoricoItem>
          ))}
        </HistoricoLista>
      )}
    </div>
  );
}
